/* eslint-disable react/prop-types */
import { useContext, useState } from 'react'
import { Button, Divider, Switch } from 'antd'
import EACard from 'Components/UI/EACard'
import EAReportContext from 'Components/UI/EAReport/Context'
import PropTypes from 'prop-types'

import exportToCSV from './utils/csv/exportToCSV'
import exportToPDF from './utils/pdf/exportToPDF'
import gerarPDFEncomenda from './utils/pdf/gerarPDFEncomenda'
import exportToXLS from './utils/xls/exportToXLS'

const columnShape = PropTypes.shape({
  title: PropTypes.string,
  dataIndex: PropTypes.string,
  exportable: PropTypes.bool,
  render: PropTypes.func
})

const columnType = PropTypes.shape(columnShape)
columnType.columns = PropTypes.arrayOf(columnType)

columnShape.columns = PropTypes.arrayOf(columnType)

const propTypes = {
  columns: PropTypes.arrayOf(columnType).isRequired,
  dataSource: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  filtrosDetalhados: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  reportName: PropTypes.string.isRequired,
  isEncomenda: PropTypes.bool,
  sumData: PropTypes.arrayOf(PropTypes.shape({})),
  allowExportDetails: PropTypes.bool
}

const defaultProps = {
  isEncomenda: false,
  sumData: null,
  allowExportDetails: false
}

/* TODO: verificar a filtragem das colunas exportáveis */
const EAReportExport = ({
  columns,
  dataSource,
  filtrosDetalhados,
  reportName,
  isEncomenda = false,
  sumData,
  allowExportDetails = false
}) => {
  const { title } = useContext(EAReportContext)
  const [exportDetails, setExportDetails] = useState(false)

  if (dataSource.length === 0) {
    return null
  }

  const handlePDFClick = () => {
    if (isEncomenda) {
      gerarPDFEncomenda({
        dataSource,
        filtrosDetalhados,
        reportName,
        title,
        sumData
      })
    } else {
      exportToPDF({
        columns: columns.filter((column) => column.exportable !== false),
        dataSource,
        filtrosDetalhados,
        reportName,
        title,
        exportDetails
      })
    }
  }

  return (
    <EACard size="small" title="Exportar dados do relatório">
      <Button
        onClick={() =>
          exportToCSV({
            columns: columns.filter((column) => column.exportable !== false),
            dataSource,
            reportName,
            exportDetails,
            sumData
          })
        }
      >
        CSV
      </Button>

      <Divider type="vertical" />

      <Button onClick={handlePDFClick}>PDF</Button>

      <Divider type="vertical" />

      <Button
        onClick={() =>
          exportToXLS({
            columns: columns.filter((column) => column.exportable !== false),
            dataSource,
            reportName,
            sumData,
            exportDetails
          })
        }
      >
        XLS
      </Button>

      {allowExportDetails ? (
        <>
          <Divider type="vertical" />
          <Switch title="Exportar Detalhes" checked={exportDetails} onChange={setExportDetails} />
        </>
      ) : (
        ''
      )}
    </EACard>
  )
}

EAReportExport.propTypes = propTypes
EAReportExport.defaultProps = defaultProps

export default EAReportExport
